/* --- GrooveFx Connectivity Health Check --- */
export async function runDiagnostic() {
    console.log("🚀 Starting GrooveFx Multi-modal Diagnostic...");

    // 1. Check Microphone Permissions
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        console.log("✅ Mic Access: Granted");
        stream.getTracks().forEach(track => track.stop());
    } catch (e) {
        console.error("❌ Mic Access: Denied. This will kill Livestreaming.");
    }

    // 2. Test STUN Server (The 'Phonebook' of WebRTC)
    const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.l.google.com:19302" }] });
    pc.onicecandidate = (event) => {
        if (event.candidate) console.log("✅ STUN Reachable: Network allows peer connections.");
    };
    pc.createDataChannel("test");
    await pc.createOffer().then(offer => pc.setLocalDescription(offer));

    // 3. Check WebSocket Connectivity (The Gemini Bridge)
    const testWS = new WebSocket("wss://echo.websocket.org");
    testWS.onopen = () => {
        console.log("✅ WSS Protocol: Supported. Secure WebSockets are open.");
        testWS.close();
    };
    testWS.onerror = () => console.error("❌ WSS Protocol: Blocked. Check your firewall/VPN.");
}